<template>
    <!-- 上传文件弹窗[[ -->
    <div class="g-popup js-popup-upload" v-if="modal.showSubmitFile" style="z-index: 2">
        <div class="popup-con upload-popup">
            <div class="popup-close js-close-view">
                <i class="ico ico-close" @click="cancelSubmitFile"></i>
            </div>
            <h5 class="popup-title">上传验收件</h5>
            <div class="confirm-content">
                <file-upload-cloud :maxSize="1024*1024*1024" @addfile="addFile" @completed="uploadFileCompleted"
                    @uploadFail="uploadFail"></file-upload-cloud>
                <ul class="files-list iip-con-box g-scrollbar" style="height: auto;max-height: 204px">
                    <li v-loading="item.loading" style="font-size: 20px;" element-loading-spinner="el-icon-loading"
                        class="files-item iip-con f-clearfix" v-for="(item, key) in fileList" :key="key">
                        <div class="file-ico"></div>
                        <div class="file-message">
                            <div class="file-name f-hide-col-1">{{ item.fileName }}</div>
                            <div class="loading-outer">
                                <!-- <div class="loading-inner" :style="{width:`${file.percent}%`}"></div> -->
                                <div class="loading-inner" :style="{width:`${100}%`}"></div>
                            </div>
                        </div>
                        <div class="ico ico-circular-close f-fr" @click="deleteFile(item, key)"></div>
                    </li>
                </ul>
                <div class="btn-group f-clearfix">
                    <a class="g-btn f-fl" href="javascript:;" @click="doSubmitFile" :class="{'loading-gray': loading}">确认</a>
                    <a class="g-btn f-fr" href="javascript:;" @click="cancelSubmitFile">取消</a>
                </div>
                <div style="width: 100%; height: 1rem;font-size: 14px;margin-top: 1rem;color: #FD7E28">
                    <span>支持文件格式：rar,7z,zip</span>
                </div>
            </div>
        </div>
    </div>
    <!-- 上传文件弹窗]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/order/order.scss';
.loading-gray {
    filter: grayscale(100%);
}
</style>

<script>
import fileUploadCloud from "Components/v4/upload/fileUploadCloud";
import { PersonAttachmentSubmit } from "Services/getData.js";
export default {
    name: "acceptance_file_upload.vue",
    data() {
        return {
            modal: {
                showSubmitFile: false
            },
            fileList: [],
            uploadFileIds: [], // 暂存上传file id
            demandItemId: "",
        };
    },
    computed: {
        loading() {
            let loading = false;
            this.fileList.map(v => {
                if (v.loading) {
                    loading = true;
                }
            })
            return loading;
        }
    },
    components: {
        fileUploadCloud
    },
    methods: {
        uploadFail() {
            this.uploadFileIds.pop();
        },
        showDialog(demandItemId) {
            this.modal.showSubmitFile = true;
            this.fileList = [];
            this.demandItemId = demandItemId;
        },
        cancelSubmitFile() {
            this.modal.showSubmitFile = false;
            // 清空上传列表
            this.uploadFileIds = [];
            this.fileList = [];
        },
        addFile(res) {
            // 添加文件
            res.loading = true;
            this.fileList.push(res);
        },
        uploadFileCompleted(res) {
            this.fileList.forEach(v => {
                if (v.fileName === res.fileName) {
                    v.id = res.id;
                    v.loading = false;
                }
            })
        },
        deleteFile(file, key) {
            this.fileList.splice(key, 1);
        },
        async doSubmitFile() {
            // 提交验收件
            let loading = false;
            this.uploadFileIds = this.fileList.map(v => {
                if (v.loading) {
                    loading = true;
                }
                return v.id;
            })
            if (!this.loading) {
                if (this.uploadFileIds.length === 0) {
                    this.$alert("请先上传验收件");
                    return false;
                }
                let param = {
                    attachmentIds: this.uploadFileIds.join(","),
                    demandItemId: this.demandItemId
                };
                let res = await PersonAttachmentSubmit(param);
                if (res.status === 200 && res.data.code == 0) {
                    if (res.data.code == 0) {
                        this.$alert("操作成功");
                        this.$emit("change", res.data.data);
                        this.cancelSubmitFile();
                    }
                }
            }
        }
    }
};
</script>

